module.exports = __webpack_public_path__ + "static/media/historia_cover.73855fc3.jpg";